import { render, staticRenderFns } from "./willingness.vue?vue&type=template&id=44865640&"
import script from "./willingness.vue?vue&type=script&lang=js&"
export * from "./willingness.vue?vue&type=script&lang=js&"
import style0 from "./willingness.vue?vue&type=style&index=0&id=44865640&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports